export class WrappedExceptionError extends Error {
  constructor(err, action) {
    super();
    this.message = err.message;
    this.stack = err.stack;
    this.action = action;
  }
}
